import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { Breadcrumbs } from 'dibs-elements/exports/Breadcrumbs';

function BuySharedBreadcrumbsComponent({ buyPage }) {
    return buyPage.breadcrumbs.length ? <Breadcrumbs breadcrumbs={buyPage.breadcrumbs} /> : null;
}

BuySharedBreadcrumbsComponent.propTypes = {
    buyPage: PropTypes.object.isRequired,
};

export const BuySharedBreadcrumbs = createFragmentContainer(BuySharedBreadcrumbsComponent, {
    buyPage: graphql`
        fragment BuySharedBreadcrumbs_buyPage on ItemSearchQueryConnection {
            breadcrumbs {
                path
                displayName
            }
        }
    `,
});
